// @flow

export const areaTypeConstants: {[key: string]: string} = {
	DEGREE: 'degree',
	MAJOR: 'major',
	CONCENTRATION: 'concentration',
	EMPHASIS: 'emphasis',
	ID: 'interdisciplinary',
}
